import moment from 'moment';
import { useState } from 'react';
import { CSVLink } from 'react-csv';
import { Button, Dropdown, Icon, Modal, Table } from 'semantic-ui-react';
import writeXlsxFile from 'write-excel-file';
//import { AB_SCHEMA, FF_SCHEMA, MF_SCHEMA, UM_SCHEMA } from '../../vendorConfig';

function ExportOrders(props: any) {
  let [confirmOpen, setConfirmOpen] = useState(false);
  const ordersData = props.ordersData ?? [];
  let exportData = ordersData
    .map((element) => {
      let patient = {};
      patient = props.patients && props.patients[element.patientId];
      patient &&
        props.PATIENT_ATTRIBUTES.map((attribute) => {
          let value = patient[attribute];
          if (typeof value === 'string') {
            element[attribute] = value;
          } else {
            element[attribute] = value[0];
          }
        });
      //Eat well needs member language in invoices
      if (patient && props.vendor === 'EW') {
        element['language'] = patient['language']?.[0];
      }
      return element;
    });
  // bundleName is orderName for orders created from table
  let schema: { column: any; value: any }[] = [
    { column: 'orderId', value: (order) => order.orderId },
    { column: 'orderDate', value: (order) => order.orderDate },
    { column: 'patientId', value: (order) => order.patientId },
    { column: 'bundleId', value: (order) => order.bundleId },
    { column: 'orderName', value: (order) => order.orderName },
    { column: 'bundleQuantity', value: (order) => order.bundleQuantity },
    { column: 'firstName', value: (order) => order.firstName },
    { column: 'lastName', value: (order) => order.lastName },
    { column: 'delivery_addressLine1', value: (order) => order.delivery_addressLine1 },
    { column: 'delivery_addressLine2', value: (order) => order.delivery_addressLine2 },
    { column: 'delivery_city', value: (order) => order.delivery_city },
    { column: 'delivery_state', value: (order) => order.delivery_state },
    { column: 'delivery_zip', value: (order) => order.delivery_zip },
    { column: 'homePhone', value: (order) => order.homePhone },
    { column: 'foodPrice', value: (order) => order?.foodPricing },
    { column: 'shippingFees', value: (order) => order?.shippingFees },
  ];
  if (props.vendor !== 'PK') {
    schema.push({ column: 'mobilePhone', value: (order) => order.mobilePhone });
  }

  if (props.vendor === 'OK') {
    schema.push({
      column: 'bundleItems',
      value: (order) => order.orderItems.map((orderItem) => orderItem.name + '-' + orderItem.quantity).join(', '),
    });
  }
  if (props.vendor === 'EW') {
    schema.push({
      column: 'language',
      value: (order) => order.language,
    });
  }
  schema.push({ column: 'deliveryInstructions', value: (order) => order.deliveryInstructions });

  /* if (props.vendor === 'AB') {
    schema = AB_SCHEMA.map((element) => {
      let v;
      if ('value' in element) {
        v = (order) => element.value;
      } else if ('attribute' in element) {
        if (element.attribute.includes('+')) {
          let att = element.attribute.split('+');
          v = (order) => order[att[0]] + ' ' + order[att[1]];
        } else {
          v = (order) => order[element.attribute];
        }
      }
      return { column: element.column, value: v };
    });
  }
  if (props.vendor === 'MF') {
    schema = MF_SCHEMA.map((element) => {
      let v;
      if ('value' in element) {
        v = (order) => element.value;
      } else if ('attribute' in element) {
        if (element.attribute === 'Unique ID') {
          v = (order) => 'MF_' + order['orderDate'];
        } else if (element.attribute === 'orderItems') {
          v = (order) => (order.orderItems ? order.orderItems.map((oi) => oi.name).join('\n') : '');
        } else {
          v = (order) => order[element.attribute];
        }
      }
      return { column: element.column, value: v };
    });
  }
 
  if (props.vendor === 'UM') {
    schema = UM_SCHEMA.map((element) => {
      let v;
      if ('attribute' in element) {
        if (element.column === 'Frequency_Unit') {
          v = (order) => 'Single';
        } else if (element.column === 'Frequency_Qty') {
          v = (order) => '1';
        } else if (element.column === 'Frequency_Repeat') {
          v = (order) => 'Single';
        } else if (element.column === 'Preferred_DOW') {
          v = (order) => '';
        } else if (element.column === 'Special Instructions') {
          v = (order) => order.deliveryInstructions;
        } else if (element.column === 'Program_ID') {
          v = (order) => order.patientOrg;
        } else if (element.column === 'Order_Date') {
          v = (order) => order.orderDate;
        } else if (element.column === 'SKU') {
          v = (order) => order.orderName;
        } else if (element.column === 'Phone') {
          v = (order) => order.mobilePhone || order.homePhone;
        } else {
          v = (order) => order[element.attribute];
        }
      }
      return { column: element.column, value: v };
    });
  }
 
  if (props.vendor === 'FF') {
    let newExportData = [];
    for (var orderIndex in exportData) {
      let order = exportData[orderIndex];
      let items = order.orderItems;
      for (var itemIndex in items) {
        let item = items[itemIndex];
        let temp = { ...order };
        temp['itemName'] = item['name'];
        temp['quantity'] = item['quantity'];
        newExportData.push(temp);
      }
    }
    exportData = [...newExportData];
    schema = FF_SCHEMA.map((element) => {
      let v;
      if ('value' in element) {
        v = (order) => element.value;
      } else if ('attribute' in element) {
        if (element.attribute.toString().includes('+')) {
          v = (order) => order.delivery_addressLine1 + ', ' + order.delivery_city;
        } else {
          v = (order) => order[element.attribute];
        }
      }
      return { column: element.column, value: v };
    });
  } */

  const handleExport = () => {
    writeXlsxFile(exportData, {
      schema,
      fileName: props.vendor + '-' + moment().utc().format().toString() + '.xlsx',
    });
    props.markExported();
    setConfirmOpen(false);
  };
  let csvButton = (
    <CSVLink
      style={{ color: 'black' }}
      onClick={() => {
        props.markExported();
        setConfirmOpen(false);
      }}
      filename={props.vendor + '-' + moment().utc().format().toString()}
      data={exportData && exportData}
      headers={[
        'orderId',
        'orderDate',
        'patientId',
        'bundleId',
        'orderName',
        'bundleQuantity',
        'firstName',
        'lastName',
        'delivery_addressLine1',
        'delivery_addressLine2',
        'delivery_city',
        'delivery_state',
        'delivery_zip',
        'homePhone',
        'mobilePhone',
        'deliveryInstructions',
      ]}
    >
      AS CSV
    </CSVLink>
  );
  let confirmText = '  All new orders will be marked exported';
  return (
    <>
      <Modal
        open={confirmOpen}
        onOpen={() => setConfirmOpen(true)}
        onClose={() => setConfirmOpen(false)}
        size="fullscreen"
        trigger={
          <Button
            color="green"
            icon="download"
            content={'(' + ordersData.length + ')'}
            onClick={() => setConfirmOpen(true)}
          />
        }
      >
        <Modal.Header>
          <Icon name="warning" color="yellow" /> {confirmText}
        </Modal.Header>
        <Modal.Content scrolling>
          <Table celled singleLine>
            <Table.Header>
              <Table.Row>
                {/* <Table.HeaderCell>Order Id</Table.HeaderCell>
                            <Table.HeaderCell>Member Name</Table.HeaderCell>
                            <Table.HeaderCell>Order Name</Table.HeaderCell>
                            <Table.HeaderCell>Bundle Id</Table.HeaderCell>
                            <Table.HeaderCell>Status</Table.HeaderCell> */}
                {schema.map((sc) => {
                  return <Table.HeaderCell>{sc.column}</Table.HeaderCell>;
                })}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {/* {exportData.map(ed => {
                            return (
                                <Table.Row>
                                    <Table.Cell>{ed.orderId}</Table.Cell>
                                    <Table.Cell>{ed.firstName + ' ' + ed.lastName}</Table.Cell>
                                    <Table.Cell>{ed.orderName}</Table.Cell>
                                    <Table.Cell>{ed.bundleName}</Table.Cell>
                                    <Table.Cell>{ed.status.toUpperCase()}</Table.Cell>
                                </Table.Row>
                            )
                        })} */}
              {exportData.map((ed) => {
                return (
                  <Table.Row>
                    {schema.map((sc) => {
                      return <Table.Cell>{sc.value(ed)}</Table.Cell>;
                    })}
                  </Table.Row>
                );
              })}
            </Table.Body>
          </Table>
        </Modal.Content>
        <Modal.Actions>
          {/* <Button content='Yes, Export as Excel' onClick={handleExport} positive/> */}
          <Dropdown as={Button} upward color="green" text="Export">
            <Dropdown.Menu>
              {!['AB', 'MF', 'FF'].includes(props.vendor) && <Dropdown.Item key="1">{csvButton}</Dropdown.Item>}
              <Dropdown.Item key="2" onClick={handleExport}>
                <a>AS EXCEL</a>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <Button content="Never Mind" onClick={() => setConfirmOpen(false)} negative />
        </Modal.Actions>
      </Modal>
    </>
  );
}

export default ExportOrders;
